export enum Permission {
  FulfillmentTestingCenterDevPortal = 'fulfillment_testing_center_dev_portal.view',
}
